export default __webpack_public_path__ + "static/01-47e8912da1c44cbc1d5a4ea653b20bc2.jpg";